module.exports = ".input-with-loader{\n\tposition: relative;\n}\n.input-with-loader .mat-spinner1 {\n\twidth: 1rem!important;\n    height: 1rem!important;\n    position: absolute;\n    right: 0;\n    top: 3px;\n    background: white;\n    padding: 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/enroll/enroll.component.css
// module id = ./src/app/shared/enroll/enroll.component.css
// module chunks = main